/**
 * <TutorPickerStep> — l'étape « Quel tuteur ? » (organism).
 *
 * L'élève a souvent plusieurs tuteurs ; l'écran ne pose la question que dans ce cas et saute
 * l'étape quand il n'y en a qu'un. La matière vient des séances, pas du tuteur : elle arrive
 * déjà rapprochée dans `subjectsLabel`.
 */
import React from "react"

import { Avatar } from "../../atoms/Avatar"
import { Stack } from "../../atoms/containers/Stack"
import { OptionCard } from "../../molecules/OptionCard"
import { type UIParentTutorChoice } from "../../../ports/primary/ui/types"
import { tutorShortName } from "../../../ports/primary/ui/formatters/liveSessionFormatter"

export type TutorPickerStepProps = {
    tutors: UIParentTutorChoice[]
    selectedId?: UIParentTutorChoice["tutor"]["id"]
    onSelect: (choice: UIParentTutorChoice) => void
    testID?: string
}

export function TutorPickerStep(props: TutorPickerStepProps) {
    const { tutors, selectedId, onSelect, testID } = props

    return (
        <Stack gap="2" testID={testID}>
            {tutors.map((choice) => (
                <OptionCard
                    key={choice.tutor.id}
                    label={choice.tutor.firstname}
                    description={choice.subjectsLabel}
                    selected={choice.tutor.id === selectedId}
                    onPress={() => onSelect(choice)}
                    leading={
                        <Avatar uri={choice.tutor.avatarUrl} name={tutorShortName(choice.tutor)} size={44} signed />
                    }
                />
            ))}
        </Stack>
    )
}
